import { getVueTemplate } from "../../_imports/utils/utils.common";
import { replaceAll } from "../../../utils/utils";
import BaseFormComponent from "../_imports/base-form-component.vue";
import debounce from 'lodash.throttle';
import { getContextualRecommendations } from "../../coveo-platform/_imports/coveo-platform.common";

export default {
	name: 'forms-resource-document-success-message',
	template: getVueTemplate('forms-resource-document-success-message'),
	mixins: [
		BaseFormComponent
	],
	props: {
		success: Object
	},
	data() {
		return {
			isVisible: false,
			isColumnLayout: false,
			resources: []
		}
	},
	computed: {
		resource() {
			if (this.resources) {
				return this.resources[0];
			}
		},
		successMessage() {
			let successMessage = this.success.message;

			this.addClassOnBody();

			if (CoveoWebsite.resource) {
				if (CoveoWebsite.resource.resource
					&& CoveoWebsite.resource.resource.resourceType
					&& CoveoWebsite.resource.resource.resourceType.singularLabel) {
					successMessage = replaceAll(successMessage, '{resourceType}', CoveoWebsite.resource.resource.resourceType.singularLabel.toLowerCase());
				}

				successMessage = replaceAll(successMessage, '{resourceLink}', CoveoWebsite.resource.document);
			}

			if(CoveoWebsite?.forms?.firstname !== undefined) {
				successMessage = replaceAll(successMessage, '{lead_firstname}', CoveoWebsite?.forms?.firstname);
			}

			return successMessage;
		},
	},
	watch: {
		formState() {
			this.isVisible = this.formState.formSubmitSuccess;
		},
		isVisible() {
			this.$nextTick(()=> {
				this.setFormMessageLayout();
			});
		}
	},
	mounted() {
		this.onResizeThrottle = debounce(this.setFormMessageLayout, 300);
		window.addEventListener('resize', this.onResizeThrottle);

		this.fetchContextualResource();
	},
	methods: {
		onCtaClick() {
			this.formEvent.dispatch('success-cta-click');
		},
		setFormMessageLayout(){
			this.isColumnLayout = this.$el.offsetWidth < 650;
		},
		addClassOnBody() {
			document.body.classList.add('form-message-is-visible');
		},
		fetchContextualResource() {
			if (!this.success.contextualRecommendations) {
				return;
			}

			getContextualRecommendations({
				coveoPlatform: this.success.contextualRecommendations.coveoPlatform,
				firstResult: 0,
				query: {
					aq: `@culture=='${lang}'`,
					sortCriteria: this.success.contextualRecommendations.sortCriteria || 'date descending'
				}
			}).then(response => this.resources = response.resources);
		}
	}
};